// InviteLinkPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import defaultGroupImage2 from '../../images/groups/group-1.png'
import styles from './group.module.css';
import NavHeader from '../../shared/Nav-Header';


const InviteLinkPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [groupInfo, setGroupInfo] = useState(null);
    const [error, setError] = useState(null);
    const [joining, setJoining] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchGroupInfo();
    }, [token]);

    const fetchGroupInfo = async () => {
        try {
            const response = await axios.get(`/api/group/invite-info/${token}`);
            if (response.data.success) {
                setGroupInfo(response.data.group);
                setShowModal(true);
                // console.log('Fetched group info:', response.data.group);
            }
        } catch (err) {
            // console.error('Error fetching group info:', err.message);
            setError(err.response?.data?.message || 'Failed to load group information');
        }
    };

    const handleJoinGroup = async () => {
        setJoining(true);
        try {
            const response = await axios.post(`/api/group/join-via-invite`, 
                { token },
                { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
            );

            if (response.data.success) {
                navigate(`/group/${response.data.groupId}`);
            }
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'Failed to join group';
            // console.error('Error joining group:', errorMsg);
            // If token expired or invalid, close modal
            if (err.response?.status === 410 || err.response?.status === 404) {
                setShowModal(false);
            }
        } finally {
            setJoining(false);
        }
    };

    const handleCancel = () => {
        setShowModal(false);
        navigate('/groups');
    };

    const getTimeRemaining = () => {
        if (!groupInfo?.expiresAt) return '';
        const now = new Date();
        const expires = new Date(groupInfo.expiresAt);
        const diff = expires - now;
        
        if (diff < 0) return 'Expired';
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        
        if (days > 0) {
            return `Expires in ${days} day${days > 1 ? 's' : ''} ${hours}h`;
        }
        return `Expires in ${hours} hour${hours > 1 ? 's' : ''}`;
    };

    if (error) {
        return (
            <div  >
                <div  >
                    <h2 >Invalid Invite Link</h2>
                    <p >{error}</p>
                    <button onClick={() => navigate('/groups')}>
                        Browse Groups
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
        <NavHeader/>
            {showModal && groupInfo && (
                <div >
                    <img 
                        title={groupInfo.name} 
                        src={groupInfo.profilePicture ? groupInfo.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultGroupImage2}alt="pfp" 
                        className={styles.networkProfilePicture} 
                    />                    <h1 >{groupInfo.name}</h1>
                    <span >{groupInfo.memberCount} members</span>
                    <p >{getTimeRemaining()}</p>

                    <h3 >About this Group</h3>
                    <p>{groupInfo.description}</p>
                    <p> You've been invited to join this group!</p>
                    <p>Click "Join Group" to become a member and start participating.</p>
                    <button onClick={handleJoinGroup}  disabled={joining} >
                        {joining ? 'Joining...' : 'Join Group'}
                    </button>
                    <button onClick={handleCancel} disabled={joining} >
                        Cancel
                    </button>
                </div>
            )}
        </>
    );
};

export default InviteLinkPage;